import { useZipCode } from '@customink/project-service-react-components';

export const useZipCodeValid = () => {
  const { zipCode, isLoading, isUninitialized } = useZipCode();

  const zipCodeValid: boolean = isLoading || isUninitialized || !!zipCode;

  return { zipCodeValid, zipCode };
};
